const convertTag = require('./convertTag')
const convertText = require('./convertText')
const mapNodes = require('./mapNodes')

module.exports = (nodes) => {

  const TAG_TYPE = 1
  const TEXT_TYPE = 3

  return mapNodes(nodes, (node) => {

    if (node.nodeType == TAG_TYPE) {

      return convertTag(node)

    } else

    if (node.nodeType == TEXT_TYPE) {

      return convertText(node)

    } else {

      return null

    }

  })

}



// WEBPACK FOOTER //
// ../node_modules/dom2vqua/lib/index.js